module.exports = __webpack_public_path__ + "img/rebuild.a8a193d3.jpg";